import { Box } from '@chakra-ui/react'

import Sidebar from '../Sidebar'

interface Props {
  children: React.ReactChild | React.ReactChild[]
}

const scrollProps = {
  smooth: true,
  activeClass: 'active',
  spy: true,
  duration: 300,
  offset: -100,
}

const contentStyle = {
  '& h1': {
    fontSize: {
      base: '32px',
      md: '48px',
    },
    fontWeight: 'medium',
    marginBottom: '16px',
  },

  '& h2': {
    fontSize: {
      base: '24px',
      md: '32px',
    },
    fontWeight: 'medium',
    marginBottom: '8px',
  },

  '& h3': {
    fontSize: {
      base: '20px',
      md: '24px',
    },
    fontWeight: 'medium',
    marginBottom: '8px',
  },

  '& li': {
    marginBottom: '4px',
  },

  '& p': {
    marginBottom: '24px',
  },

  '& li, & p': {
    fontSize: '16px',
    fontWeight: 'light',
    fontFamily: 'arial, san-serif',
  },

  '& strong': {
    color: 'inherit',
    fontWeight: 'bold',
  },

  '& a': {
    fontWeight: 'medium',
    color: 'primary.400',
    textDecoration: 'underline',
  },

  '& a:hover': {
    color: 'primary.600',
  },

  '& hr': {
    borderColor: 'gray.300',
  },

  '& ul, & ol': {
    display: 'grid',
    gridAutoRows: 'max-content',
    gap: '8px',
    marginBottom: '24px',
    paddingLeft: '24px',
    '& li': {
      display: 'flex',

      strong: {
        display: 'contents',
      },

      '&:not(:last-of-type)': {
        marginBottom: '8px',
      },
    },
  },

  '& ul': {
    '& li': {
      '&::before': {
        content: "''",
        minWidth: '4px',
        height: '4px',
        borderRadius: '50%',
        display: 'inline-block',
        marginRight: '12px',
        backgroundColor: 'gray.900',
        marginTop: '0.6em',
      },
    },
  },

  '& ol': {
    '& li': {
      counterIncrement: 'item',
      '&::before': {
        content: 'counter(item) ". "',
        display: 'inline-block',
        minWidth: '30px',
      },
    },
  },
}

export default function TermsNPrivacyProvider({
  children,
}: Props): React.ReactElement {
  return (
    <Box
      className="TermNPrivacyContainer"
      sx={{
        display: 'grid',
        maxWidth: '1113px',
        margin: '0 auto',
        gridTemplateColumns: {
          base: '1fr',
          md: '280px 1fr',
        },
        marginTop: {
          base: '60px',
          md: '72px',
        },
        paddingTop: '40px',
        marginBottom: '24px',
        px: {
          base: 6,
          md: 0,
        },
      }}
    >
      <Sidebar scrollProps={scrollProps} bottomBoundary="#end-content" />
      <Box
        as="main"
        sx={{
          padding: {
            base: '0',
            md: '62px 0 127px 122px',
          },
          borderLeft: {
            base: 'none',
            md: '1px solid',
          },
          borderColor: {
            base: 'transparent',
            md: 'gray.200',
          },
          ...contentStyle,
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
